import { callFunction } from "./functions-client";

// Typed calls to the `profiles` edge function group (ADR-0015).

export type ProfileType = "driver" | "company" | "recruiter" | "broker_dispatcher";

export interface Profile {
  id: string;
  type: ProfileType;
  display_name: string | null;
  headline: string | null;
  status: string;
  is_default: boolean;
  image_url?: string | null;
  created_at: string;
}

export interface CreateProfileInput {
  type: ProfileType;
  display_name?: string;
  headline?: string;
  detail?: Record<string, unknown>;
}

export const listProfiles = () => callFunction<{ profiles: Profile[] }>("profiles/list", { method: "GET" });

export const createProfile = (input: CreateProfileInput) =>
  callFunction<{ profile: Profile }>("profiles/create", { body: input });

export const setDefaultProfile = (profile_id: string) =>
  callFunction<{ ok: boolean }>("profiles/set-default", { body: { profile_id } });

export interface ProfileWithDetail {
  profile: Profile;
  detail: Record<string, unknown> | null;
}

export const getProfile = (id: string) =>
  callFunction<ProfileWithDetail>(`profiles/get?id=${encodeURIComponent(id)}`, { method: "GET" });

export const updateProfile = (input: {
  id: string;
  display_name?: string;
  headline?: string;
  detail?: Record<string, unknown>;
}) => callFunction<{ profile: Profile }>("profiles/update", { body: input });

export const PROFILE_TYPE_LABELS: Record<ProfileType, string> = {
  driver: "Driver",
  company: "Company",
  recruiter: "Recruiter",
  broker_dispatcher: "Broker / Dispatcher",
};

// Profile avatar / company logo (public bucket).
export const imageUploadUrl = (profile_id: string, ext: string) =>
  callFunction<{ upload_url: string; path: string; public_url: string }>("profiles/image-upload-url", { body: { profile_id, ext } });
export const setProfileImage = (profile_id: string, path: string) =>
  callFunction<{ image_url: string }>("profiles/set-image", { body: { profile_id, path } });
export const removeProfileImage = (profile_id: string) =>
  callFunction<{ ok: boolean }>("profiles/remove-image", { body: { profile_id } });
